function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M33.79 31.32v-5.81a5.6 5.6 0 00-5.6-5.6H17a5.6 5.6 0 00-5.6 5.6v5.81"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.59,
  cy: 8.71,
  r: 5.6,
  stroke: "#333"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M.24 1.65C.24.965.795.41 1.48.41h8.66a1.23 1.23 0 011.24 1.24v9.19L8.9 8.37H1.48A1.25 1.25 0 01.24 7.13V1.65z"
}));

function SvgCustomers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 34"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOCAzNCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBhdGggc3Ryb2tlPSIjMzMzIiBkPSJNMzMuNzksMzEuMzIgTDMzLjc5LDI1LjUxIEMzMy43OSwyMi40MTcyMDU0IDMxLjI4Mjc5NDYsMTkuOTEgMjguMTksMTkuOTEgTDE3LDE5LjkxIEMxMy45MDcyMDU0LDE5LjkxIDExLjQsMjIuNDE3MjA1NCAxMS40LDI1LjUxIEwxMS40LDMxLjMyIi8+CiAgICA8Y2lyY2xlIGN4PSIyMi41OSIgY3k9IjguNzEiIHI9IjUuNiIgc3Ryb2tlPSIjMzMzIi8+CiAgICA8cGF0aCBzdHJva2U9IiMyM0MzODYiIGQ9Ik0wLjI0LDEuNjUgQzAuMjQsMC45NjUxNjY5MSAwLjc5NTE2NjkxLDAuNDA5OTU4OTU3IDEuNDgsMC40MDk5NTg5NTcgTDEwLjE0LDAuNDA5OTU4OTU3IEMxMC40Njk2ODYyLDAuNDA3MzA4NTQ5IDEwLjc4NjY1MTIsMC41MzcwODY1NzUgMTEuMDE5NzgyMywwLjc3MDIxNzY3NCBDMTEuMjUyOTEzNCwxLjAwMzM0ODc3IDExLjM4MjY5MTUsMS4zMjAzMTM4MiAxMS4zODAwNDEsMS42NSBMMTEuMzgwMDQxLDEwLjg0IEw4LjksOC4zNyBMMS40OCw4LjM3IEMwLjc5NzQzMjUzLDguMzY0NTYwOTYgMC4yNDU0MzkwNDMsNy44MTI1Njc0NyAwLjI0LDcuMTMgTDAuMjQsMS42NSBaIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgCustomers as ReactComponent };